import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getPurchaseTaxById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreatePurchaseTax } from "..";

const EditPurchaseTax = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getPurchaseTax();
        else setLoading(false);
    }, [id]);

    const getPurchaseTax = async () => {
        try {
            const { data } = await getPurchaseTaxById(id);
            setItem(data.purchaseTax);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreatePurchaseTax from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_purchase_tax' />
};

export default EditPurchaseTax;